import { RootState } from 'store';

export const selectPropertyOwnerships = (state:RootState) => state.propertyOwnerships.propertyOwnerships;
export const selectPropertyOwnershipDetails = (state:RootState) => state.propertyOwnerships.propertyOwnershipDetails;
export const selectTotal = (state:RootState) => state.propertyOwnerships.total;
export const selectParams = (state:RootState) => state.propertyOwnerships.params;
export const selectMyPropertyOwnershipsParams = (state:RootState) => state.propertyOwnerships.myPropertyOwnershipsParams;
export const selectMyPropertyOwnershipsTotal = (state:RootState) => state.propertyOwnerships.myPropertyOwnershipsTotal;
export const selectIsMyPropertyOwnerships = (state:RootState) => state.propertyOwnerships.myPropertyOwnerships;
export const selectIsPropertyOwnershipsGroups = (state:RootState) => state.propertyOwnerships.propertyOwnershipsGroups;
export const selectFormData = (state:RootState) => state.propertyOwnerships.formData;
